module.exports = __webpack_public_path__ + "static/media/isotipo-pd-blanco.7ea894f4.png";